import { connect } from 'react-redux';

import { resetPassword } from './actions';
import PasswordResetPage from './PasswordResetPage';
import { State } from './reducer';

function mapStateToProps(state: { passwordReset: State }): {
	isFetching: boolean;
} {
	return {
		isFetching: state.passwordReset.request !== null,
	};
}

const actions = {
	onResetPassword: resetPassword,
};

export default connect(mapStateToProps, actions)(PasswordResetPage);
